export const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";

